// RenderView.js (Separate file for renderView)

import React, { memo } from 'react';
import { Table, Tag } from 'antd';
import TableView from './TableView'; // Replace with your actual path
import ListView from './ListView'; // Replace with your actual path
import PivotView from './PivotView'; // Replace with your actual path
import GanttChart from './GanttChart'; // Replace with your actual path
import StackedChart from './StackedChart'; // Replace with your actual path
import MultiMeasure from './Multimeasure';
import Waterfall from './Waterfall'; // Replace with your actual path
import NotepadApp from './Note';
import Milestones from './Milestones';
import WorkstreamactionTable from './WorkstreamActionTable';
import UserTable from './Users';
import axios from 'axios';

const RenderView = memo(({
  searchResults,
  selectedInfoMenu,
  initiatives,
  milestones,
  users,
  actionItem,
  selectedMenu,
  otherElementRef,
  colorByAttribute,
  initiativeColors,
  milestoneColors,
  actionItemColors,
  aggregationAttribute,
  swapVisible,
  selectedMetric,
  sumVisible,
  tableDownloadVisible,
  setTableDownloadVisible,
  setCopyVisible,
  copyVisible,
  groupedImpact,
  groupedData,
  selectedImpactGroup,
  selectedTimePeriod,
  selectedDateRange,
  visibleColumns,
  setCurrentFilter,
  setFilterVisible,
  currentFilter,
  setFilterHistory,
  setMilestoneCurrentFilter,
  milestoneCurrentFilter,
  setActionItemCurrentFilter,
  actionItemCurrentFilter,
  selectedGroup,
  xAxis,
  setXAxis,
  yAxis,
  setYAxis,
  attributeFilters,
  setSelectedImpactGroup,
  isAllGroupsExpanded,
  setIsAllGroupsExpanded,
  sectors,
  sortField,
  sortOrder
}) => {
  if (searchResults.length > 0) {
    return (
      <Table
        dataSource={searchResults.map((result, index) => ({ ...result, key: index }))}
        columns={[
          {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (text) => <Tag color="blue">{text}</Tag>,
          },
          {
            title: 'Number',
            dataIndex: (record) => {
              switch (record.type) {
                case 'Initiative':
                  return record.data.initiativeNumber;
                case 'Milestone':
                  return record.data.milestoneNumber;
                case 'Impact':
                  return record.data.impactNumber;
                case 'KPI':
                  return record.data.KPINumber;
                case 'Workstream Action':
                  return record.data.actionItemNumber;
                default:
                  return '';
              }
            },
            key: 'number',
          },
          {
            title: 'Name',
            dataIndex: (record) => {
              switch (record.type) {
                case 'Initiative':
                  return record.data.initiativeName;
                case 'Milestone':
                  return record.data.name;
                case 'Impact':
                  return record.data.typeOfImpact;
                case 'KPI':
                  return record.data.UniversalKPI;
                case 'Workstream Action':
                  return record.data.workstreamActionName;
                default:
                  return '';
              }
            },
            key: 'name',
          },
          {
            title: 'Initiative Name',
            dataIndex: (record) => {
              if (record.initiative) {
                return record.initiative.initiativeName;
              }
              return record.type === 'Initiative' ? record.data.initiativeName : '';
            },
            key: 'initiativeName',
          },
          {
            title: 'Details',
            dataIndex: (record) => {
              let detail = record.data;
              if (record.type === 'Milestone') {
                detail = record.data;
              } else if (record.data.data) {
                detail = record.data.data;
              }
              return JSON.stringify(detail);
            },
            key: 'details',
          },
        ]}
        rowKey='_id'
      />
    );
  }

  switch (selectedMenu.key) {
    case 'List':
      if (selectedInfoMenu === 'initiatives') {
        return (
          <div style={{ marginTop: '50px' }}>
            <TableView
              initiatives={initiatives}
              otherElementRef={otherElementRef}
              colorByAttribute={colorByAttribute}
              initiativeColors={initiativeColors}
              visibleColumn={visibleColumns}
              setCurrentFilter={setCurrentFilter}
              setFilterVisible={setFilterVisible}
              currentFilter={currentFilter}
              setFilterHistory={setFilterHistory}
              sortField={sortField}
              sortOrder={sortOrder}
            />
          </div>
        );
      }
      if (selectedInfoMenu === 'milestones') {
        return (
          <div style={{ marginTop: '50px' }}>
            <Milestones
              milestones={milestones}
              users={users}
              otherElementRef={otherElementRef}
              colorByAttribute={colorByAttribute}
              milestoneColors={milestoneColors}
              initiativeColors={initiativeColors}
              initiatives={initiatives}
              visibleColumn={visibleColumns}
              setMilestoneCurrentFilter={setMilestoneCurrentFilter}
              setCurrentFilter={setCurrentFilter}
              setFilterVisible={setFilterVisible}
              milestoneCurrentFilter={milestoneCurrentFilter}
              setFilterHistory={setFilterHistory}
            />
          </div>
        );
      }
      if (selectedInfoMenu === 'workstreamactions') {
        return (
          <div style={{ marginLeft: '150px' }}>
            <WorkstreamactionTable
              actionItem={actionItem}
              otherElementRef={otherElementRef}
              colorByAttribute={colorByAttribute}
              actionItemColors={actionItemColors}
              visibleColumn={visibleColumns}
              users={users}
              setActionItemCurrentFilter={setActionItemCurrentFilter}
              setFilterVisible={setFilterVisible}
              actionItemCurrentFilter={actionItemCurrentFilter}
              setFilterHistory={setFilterHistory}
            />
          </div>
        );
      }
      if (selectedInfoMenu === 'users') {
        return (
          <div style={{ marginTop: '50px' }}>
            <UserTable users={users} />
          </div>
        );
      }
    case 'Table':
      return (
        <div style={{ marginTop: '50px' }}>
          <ListView
            initiatives={initiatives}
            actionItems={actionItem}
            milestones={milestones}
            aggregationAttribute={aggregationAttribute}
            colorByAttribute={colorByAttribute}
            initiativeColors={initiativeColors}
            swapVisible={swapVisible}
            sumVisible={sumVisible}
            tableDownloadVisible={tableDownloadVisible}
            setTableDownloadVisible={setTableDownloadVisible}
            setCopyVisible={setCopyVisible}
            copyVisible={copyVisible}
            selectedImpactGroup={selectedImpactGroup}
            setSelectedImpactGroup={setSelectedImpactGroup}
            selectedTimePeriod={selectedTimePeriod}
            selectedDateRange={selectedDateRange}
            groupedData={groupedData}
            selectedGroup={selectedGroup}
            milestoneColors={milestoneColors}
            actionItemColors={actionItemColors}
            users={users}
            isAllGroupsExpanded={isAllGroupsExpanded}
            setIsAllGroupsExpanded={setIsAllGroupsExpanded}
            sectors={sectors}
          />
        </div>
      );
    case 'Pivot':
      return (
        <div style={{ marginTop: '50px' }}>
          <PivotView initiatives={initiatives} />
        </div>);
    case 'Gantt':

      return (
        <div style={{ marginTop: '50px' }}>
          <GanttChart initiatives={initiatives} />
        </div>
      );
    case 'Stacked':
      return (
        <div style={{ marginTop: '50px' }}>
          <StackedChart
            initiatives={initiatives}
            selectedGroup={selectedGroup}
            xAxis={xAxis}
            yAxis={yAxis}
            attributeFilters={attributeFilters}
            colorByAttribute={colorByAttribute}
            initiativeColors={initiativeColors}

          />
        </div>
      );
    case 'Multi-Measure':
      return (
        <div style={{ marginTop: '50px' }}>
          <MultiMeasure initiatives={initiatives} />
        </div>
      );
    case 'Waterfall':
      return (
        <div style={{ marginTop: '50px' }}>
          <Waterfall
            initiatives={initiatives}
            selectedGroup={selectedGroup}
            groupedData={groupedData} // This is where groupedData is passed to Waterfall
            colorByAttribute={colorByAttribute}
            initiativeColors={initiativeColors}
            xAxis={xAxis}
            setXAxis={setXAxis}
            yAxis={yAxis}
            setYAxis={setYAxis}
          />
        </div>
      );
    case 'Note':
      return (
        <div style={{ marginTop: '50px' }}>
          <NotepadApp readOnly={false} />
        </div>
      );
    default:
      return null;
  }
});

export default RenderView;